const organizationTreeItems = state => state.organizationTreeItems
const organizationTreePlaceholder = state => state.organizationTreePlaceholder
const prevOrganizationTreeItems = state => state.prevOrganizationTreeItems
const prevOrganizationTreePlaceholder = state => state.prevOrganizationTreePlaceholder
const sourceItem = state => state.sourceItem
const destinationItem = state => state.destinationItem
const sourceItemIdAndType = state => state.sourceItemIdAndType
const destinationItemIdAndType = state => state.destinationItemIdAndType
const asideBarHasChanged = state => state.asideBarHasChanged
const latestFullTree = state => state.latestFullTree
const isSearchActive = state => state.isSearchActive

export default {
    organizationTreeItems,
    organizationTreePlaceholder,
    prevOrganizationTreeItems,
    prevOrganizationTreePlaceholder,
    sourceItem,
    destinationItem,
    sourceItemIdAndType,
    destinationItemIdAndType,
    asideBarHasChanged,
    latestFullTree,
    isSearchActive
}
